<template>
    <vx-expandable-card>
        <template v-slot:header>
            <div class="flex flex-col gap-2">
                <vx-popover v-if="props.disabled" hover :arrow="true" placement="top" class="cursor-pointer">
                    <vx-badge size="xs" color="amber">
                        Locked
                        <font-awesome-icon widthAuto :icon="faLockKeyhole"></font-awesome-icon>
                    </vx-badge>
                    <template v-slot:content>
                        <span>The category is managed by and inherited from the flow.</span>
                    </template>
                </vx-popover>
                <span>Category</span>
            </div>
        </template>
        <template v-slot:headerSubtitle>
            <slot name="headerSubtitle">
                Optionally select the category that best describes this resource.
            </slot>
        </template>
        <template v-slot:content>
            <vx-selectable
                data-test="category-select"
                placeholder="Search"
                size="lg"
                :options="resourceCategoriesOptions"
                v-model="model"
                :clearable="false"
                :reduce="(option) => option.value"
                :disabled="props.disabled"
            >
                <template v-slot:option="{ option }">
                    <div class="flex items-center gap-2">
                        <font-awesome-icon class="text-slate-500 text-xs" :icon="option.icon"></font-awesome-icon>
                        <span>{{ option.label }}</span>
                    </div>
                </template>
                <template v-slot:selected-option="{ option }">
                    <div class="flex items-center gap-2">
                        <font-awesome-icon v-if="option.icon" class="text-slate-500 text-xs" :icon="option.icon"></font-awesome-icon>
                        <span>{{ option.label }}</span>
                    </div>
                </template>
            </vx-selectable>
            <vx-button
                v-if="model && !props.disabled"
                color="muted"
                size="sm"
                type="button"
                class="mt-2"
                @click.prevent="emit('reset')"
            >
                Reset Category
                <font-awesome-icon widthAuto :icon="faUndo"></font-awesome-icon>
            </vx-button>
        </template>
    </vx-expandable-card>
</template>
<script setup>
import {
    VxExpandableCard,
    VxPopover,
    VxBadge,
    VxSelectable,
    VxButton,
} from '@voxie/frontend-components';
import { FontAwesomeIcon } from "@fortawesome/vue-fontawesome";
import { faLockKeyhole, faUndo } from "@fortawesome/pro-solid-svg-icons";
import { resourceCategoriesOptions } from '~/constants/categories';

const props = defineProps({
    disabled: {
        type: Boolean,
        default: false,
    },
});

const emit = defineEmits(['reset']);

const model = defineModel({
    type: String,
    default: '',
});
</script>
